var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiRsUndo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_4348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9999 23.9994H21.9999C21.9978 22.1436 21.2596 20.3643 19.9473 19.052C18.635 17.7397 16.8558 17.0016 14.9999 16.9994H10.1699V23.4134L0.876895 14.1204C0.314481 13.5579 -0.00146484 12.7949 -0.00146484 11.9994C-0.00146484 11.204 0.314481 10.441 0.876895 9.87845L10.1699 0.585449V6.99945H14.9999C17.386 7.0021 19.6737 7.95116 21.3609 9.63841C23.0482 11.3257 23.9973 13.6133 23.9999 15.9994V23.9994ZM8.1699 5.41345L2.29089 11.2924C2.10342 11.48 1.99811 11.7343 1.99811 11.9994C1.99811 12.2646 2.10342 12.5189 2.29089 12.7064L8.1699 18.5854V14.9994H14.9999C16.3427 14.9994 17.6685 15.3001 18.8799 15.8797C20.0912 16.4592 21.1574 17.3028 21.9999 18.3484V15.9994C21.9978 14.1436 21.2596 12.3643 19.9473 11.052C18.635 9.73974 16.8558 9.00157 14.9999 8.99945H8.1699V5.41345Z",
    fill: "#374957"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_4348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiRsUndo);
export default __webpack_public_path__ + "static/media/fi-rs-undo.19e3816183b3df1832e2026e30464d74.svg";
export { ForwardRef as ReactComponent };